export enum UserRole{
    Admin = "Admin",
    EducationTeam = "EducationTeam",
    EducationTeamVisitor = "EducationTeamVisitor",
    USEducationEventSpeakerOwners = "USEducationEventSpeakerOwners",
}

export type UserRoles = {
    [key in UserRole]?: boolean;
}